import axiosInstance from "./axios/axios.js";

const logout = (userid, sessionout = "false") => {
  let token = localStorage.getItem("csrfToken");
  axiosInstance
    .post(`/vozo/updatelogout?id=${token}&uid=${userid}`)
    .then(() => {
      localStorage.clear();
      if (sessionout === true) {
        localStorage.setItem("timeoutmsg", true);
      } else {
        localStorage.setItem("logout", true);
      }
      window.location.href = "/";
    })
    .catch((err) => {
      console.log(err);
      localStorage.clear();
      localStorage.setItem("logout", true);
      window.location.href = "/";
    });
};

export default logout;
